import { Helmet } from "react-helmet-async";
import { breadcrumbSchema, type BreadcrumbItem } from "./schema";

export default function BreadcrumbSchema({ items }: { items: BreadcrumbItem[] }) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema(items))}
      </script>
    </Helmet>
  );
}
